module.exports = __webpack_public_path__ + "img/tbQRCode.958301ed.png";